import React, { Fragment } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { UserbackSettings } from '../../../../core/api/models';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import validator from 'validator';
import { TimePeriodOnly } from '../../../../core/components/time-period/time-period-only';
import {
  isTimePeriodValid,
  ITimePeriodData,
} from '../../../../core/components/time-period/custom-time-period';
import { Multiselect } from 'react-widgets';
import { AccountType, convertPascalCaseToWords } from '../../../../core';

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: UserbackSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: UserbackSettings;
  error?: string;
}> = (props) => {
  const { control, handleSubmit, errors, watch } = useForm<UserbackSettings>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
    shouldUnregister: true,
    defaultValues: props.data,
  });

  const renderUserbackToken = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Userback Token</label>
          <Controller
            control={control}
            name="userbackToken"
            defaultValue={props.data?.userbackToken}
            render={({ onChange, value, name }) => (
              <input
                type="string"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Userback Token"
                name={name}
                value={value}
                onChange={onChange}
                id="userbackToken"
              />
            )}
          />
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">Update Userback Settings</h4>
        <div className="row gutter-10">
          {renderUserbackToken()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
